import * as React from 'react'
import Navbar from '../setup/Navbar'
import { Container, Grid2 } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import StickyHeadTable from '../../BuiltInComponent/TableWithPagination'
import Loading from '../../BuiltInComponent/Loading'
import { getRecipeMasterData } from '../../features/AdminManagement/recipeSlice'
import HeadingText from '../../BuiltInComponent/HeadingTest'

export default function PurchaseRequestList() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { masterData, isLoading } = useSelector((state) => state.recipe)

    React.useEffect(() => {
        dispatch(getRecipeMasterData())
        // dispatch(getPurchaseDetailData('blank'))
    }, [dispatch])

    const tableColumns = [
        { fieldName: 'itemCode', cName: 'Item Code', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'itemDesc', cName: 'Item Name', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'totalItems', cName: 'Total No of Items', textAlign: 'left', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'center', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 80, status: 'dis', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 80, status: 'dis', dType: 'string' },
    ];

    const onEditClick = async (itemCode) => {
        navigate('/AddRecipe', { state: { itemHeadCode: itemCode } })
    }
    const onDeleteClick = async (itemCode) => { }

    return (
        <>
            <Navbar />
            <Container>
                <Grid2 container spacing={2} sx={{ marginTop: 2, marginBottom: 2 }}>

                    <Grid2 size={3}></Grid2>
                    <Grid2 size={6}>
                        <HeadingText text="Recipe Listing" />
                    </Grid2>
                    <Grid2 size={3}></Grid2>
                    <Grid2 size={3}></Grid2>
                    <Grid2 size={6}>
                        {isLoading ? <Loading /> :
                            <StickyHeadTable tableColumns={tableColumns} tableData={masterData && masterData}
                                onEditClick={onEditClick} onDeleteClick={onDeleteClick} perPage={50} />
                        }

                    </Grid2>
                    <Grid2 size={3}></Grid2>
                </Grid2>
            </Container>
        </>
    )
}